import React from "react"
import PropTypes from "prop-types"

const normalize = str =>
  str
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()

const HighlightedText = ({ text, query, sx }) => {
  const safeText = String(text || "")
  const q = String(query || "").trim()

  if (!q) return <span style={sx}>{safeText}</span>

  const normText = normalize(safeText)
  const normQ = normalize(q)

  // Los índices se calculan sobre `normText`/`normQ` pero se usan para cortar
  // `safeText` (el original, sin normalizar): esto sólo da el resultado correcto
  // si quitar diacríticos no cambia la longitud del string. Es el caso para las
  // tildes del español (NFD + strip de diacríticos es 1:1 carácter a carácter),
  // pero no para la İ turca ni ligaduras como "ﬁ", donde el resaltado quedaría
  // desalineado. Aceptable porque el catálogo CYPE es en español.
  const parts = []
  let cursor = 0
  let idx = normText.indexOf(normQ, cursor)

  while (idx !== -1) {
    if (idx > cursor)
      parts.push({ str: safeText.slice(cursor, idx), highlight: false })
    parts.push({
      str: safeText.slice(idx, idx + normQ.length),
      highlight: true,
    })
    cursor = idx + normQ.length
    idx = normText.indexOf(normQ, cursor)
  }

  if (cursor < safeText.length)
    parts.push({ str: safeText.slice(cursor), highlight: false })

  if (!parts.some(p => p.highlight)) return <span style={sx}>{safeText}</span>

  return (
    <span style={sx}>
      {parts.map((part, i) =>
        part.highlight ? (
          <mark
            key={i}
            style={{
              background: "rgba(255,211,41,0.55)",
              color: "inherit",
              borderRadius: 3,
              padding: 0,
              fontWeight: 800,
            }}
          >
            {part.str}
          </mark>
        ) : (
          <React.Fragment key={i}>{part.str}</React.Fragment>
        ),
      )}
    </span>
  )
}

HighlightedText.propTypes = {
  text: PropTypes.string,
  query: PropTypes.string,
  sx: PropTypes.object,
}

HighlightedText.defaultProps = {
  text: "",
  query: "",
  sx: {},
}

export default HighlightedText
